import { render, staticRenderFns } from "./alo-ai-bots-selector.vue?vue&type=template&id=52402458"
import script from "./alo-ai-bots-selector.vue?vue&type=script&lang=js"
export * from "./alo-ai-bots-selector.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports